import List from "./components/List"
import MyList from "./components/MyList"
import Form from "./components/Form"

let module = "notifications"

export default [
  {
    path: "my-notifications",
    component: MyList,
    meta: { module: module + "-my", permissions: ["all"] }
  },
  {
    path: "notifications",
    component: List,
    meta: { module: module, permissions: ["all"] }
  },
  /*{
    path: "notifications/create",
    component: Form,
    props: true,
    meta: { module: module, permissions: ["notification-create"] }
  },
  {
    path: "notifications/edit/:id",
    component: Form,
    props: true,
    meta: { module: module, permissions: ["notification-edit"] }
  },*/
]
